import axios from 'axios';
import { STATUSCODE } from '../../common/constants';
import { axiosPost } from '../../helper/fetch';

export const loginAsync = async (user) => {
//   const res = await axios({
//     url: 'api/auth',
//     method: 'POST',
//     data: JSON.stringify(user),
//   });
//   return res.data;
// };
  try {
    const res = await axiosPost('api/auth', user);
    console.log('LOGIN RES: ', res.data);
    return res.data;
  } catch (err){
    if (axios.isAxiosError(err)) {
      const status = err.response?.status;          // ej: 401, 423
      const data = err.response?.data;              // ej: { code, message }
      const code = data?.code;                      // "INVALID_CREDENTIALS" | "IP_BLOCKED" | ...
      const message =
        data?.message ||
        (status === 401
          ? 'Usuario o contraseña inválidos.'
          : 'Ocurrió un error al iniciar sesión.');

      console.log('LOGIN ERROR:', status, code, message, data);

      // devolvés un error "bonito" para tu UI
      return Promise.reject({ status, code, message });
    }

    // error no-axios (network grave, etc.)
    console.error('LOGIN ERROR (unknown):', err);
    return Promise.reject({
      status: 0,
      code: 'UNKNOWN',
      message: 'No se pudo contactar al servidor.',
    });
  }
};

// Se solicitan los datos del usuario indicado en el header token.
export const getIsAuthAsync = async () => {
  const res = await axios({
    url: 'api/user/userinfo',
    method: 'GET',
  });
  console.log('call api/user/userinfo');
  return res.status === STATUSCODE.Ok;
};

// MFA verify ==============================================================================
export const verifyMfaAsync = async ({ token, mfaToken, code }) => {
  try {
    const ticket = token || mfaToken;
    
    const res = await axiosPost('api/auth/mfa/verify', { token, code });
    return res.data;
  } catch (err) {
    if (axios.isAxiosError(err)) {
      const status = err.response?.status;
      const data = err.response?.data;

      const codeResp = data?.code;
      const message = data?.message || (status === 401 ? 'Código MFA inválido.' : 'No se pudo validar el MFA.');

      return Promise.reject({ status, code: codeResp, message });
    }

    return Promise.reject({
      status: 0,
      code: 'UNKNOWN',
      message: 'No se pudo contactar al servidor.',
    });
  }
};

// ===== FUTURO: MFA por email (TODO) =====
export const resendMfaEmailAsync = async ({ mfaToken }) => {
  const res = await axiosPost('api/auth/mfa/email/resend', { mfaToken });
  return res.data;
};
// ==============================================================================================

export const logoutAsync = async () => {
  await axios({
    url: 'api/auth/logout',
    method: 'POST',
  });
};

export const loginImpersonateAsync = async (loginAsUser) => {
  const { data } = await axiosPost('api/auth/user/impersonate/', loginAsUser);
  console.log(">>>>> ", data)
  return data;
};
